module.exports = __webpack_public_path__ + "img/zs2.65896b15.png";